import React, { useState } from "react";
import {
  Button,
  Input,
  Select,
  SelectItem,
  Checkbox,
  Alert,
} from "@heroui/react";

const UserForm = ({
  formData,
  setFormData,
  onSubmit,
  onCancel,
  getAdminDashboardUsers,
  setShowForm,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleRoleChange = (key) => {
    setFormData((prev) => ({
      ...prev,
      role: key,
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setShowAlert(false);
      setAlertMessage("");

      if (formData.username !== "") {
        let uname = formData.username;
        console.log("Username input value:", uname);
        const regex = /^[a-zA-Z0-9]{6,10}$/;
        if (!regex.test(uname)) {
          setErrorMessage(
            "Username must be 6–10 characters, only letters and numbers allowed."
          );
          setShowErrorAlert(true);

          setTimeout(() => {
            setAlertMessage("");
            setShowAlert(false);
            setErrorMessage("");
            setShowErrorAlert(false);
          }, 2000);

          return;
        } else {
          setAlertMessage("");
          setShowAlert(false);
          setErrorMessage("");
          setShowErrorAlert(false);
        }
      }

      formData.user_id = formData.user_id || null;
      formData.created_by = localStorage.getItem("uid");

      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      const baseUrl = process.env.REACT_APP_API_HOST;
      const url = formData.user_id
        ? `${baseUrl}/admin/update/user`
        : `${baseUrl}/admin/add/user`;

      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formData),
      };

      const response = await fetch(url, requestOptions);

      const result = await response.json();
      console.log("Result from user registration:", result);

      if (result.success === false) {
        throw new Error(result.message || "Failed to register/update user.");
      }

      let successMessage = formData.user_id
        ? "User updated successfully!"
        : "User added successfully!";

      getAdminDashboardUsers();
      setAlertMessage(successMessage);
      setShowAlert(true);
      // if (!formData.user_id) {
      // setFormData({
      //   email: "",
      //   name: "",
      //   username: "",
      //   wallet_balance: "",
      //   phone: "",
      //   password: "",
      //   role_id: "user",
      //   status: "",
      // });
      // }
      setTimeout(() => {
        setAlertMessage("");
        setShowAlert(false);
        setErrorMessage("");
        setShowErrorAlert(false);
        setShowForm(false);
      }, 2000);
    } catch (err) {
      console.error("Error adding user:", err.message);
      setErrorMessage(err.message || "Something went wrong");
      setShowErrorAlert(true);
      setTimeout(() => {
        setAlertMessage("");
        setShowAlert(false);
        setErrorMessage("");
        setShowErrorAlert(false);
      }, 2000);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      {showAlert && (
        <Alert
          color="success"
          className="mb-4"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      )}
      {showErrorAlert && (
        <Alert
          color="danger"
          className="mb-4"
          onClose={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {formData.user_id ? "Edit User" : "Add New User"}
      </h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Full Name
            </label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              placeholder="Enter full name"
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone
            </label>
            <Input
              type="number"
              name="phone"
              value={formData.phone}
              placeholder="Enter phone number"
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Username
            </label>
            <Input
              type="text"
              name="username"
              value={formData.username}
              placeholder="Enter username (6–10 characters, letters and numbers only)"
              // pattern="^[a-zA-Z0-9]{6,10}$"
              // title="Username must be 6–10 characters, letters and numbers only"
              onChange={handleInputChange}
              required
            />
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <Input
              type="email"
              name="email"
              value={formData.email}
              placeholder="Enter email address"
              onChange={handleInputChange}
              // required
            />
          </div> */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <Input
              type="password"
              name="password"
              placeholder={
                formData.user_id
                  ? "Leave blank to keep current password"
                  : "Enter password"
              }
              value={formData.password}
              onChange={handleInputChange}
              required={!formData.user_id}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Role
            </label>
            <Select
              defaultSelectedKeys={["user"]}
              selectedKeys={[formData.role || "user"]}
              onSelectionChange={(keys) =>
                handleRoleChange(Array.from(keys)[0])
              }
              placeholder="Select a role"
            >
              <SelectItem key="user">User</SelectItem>
              <SelectItem key="admin">Admin</SelectItem>
              <SelectItem key="operator">Operator</SelectItem>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Wallet Balance
            </label>
            <Input
              type="number"
              name="wallet_balance"
              placeholder="Enter wallet balance"
              value={formData.wallet_balance || ""}
              // placeholder="Enter password"
              // value={formData.password}
              onChange={handleInputChange}
              required
              readOnly={!!formData.user_id}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              User Active
            </label>
            <Checkbox
              size="md"
              color="success"
              isSelected={formData.status === 1}
              // defaultSelected={formData.status === 1}
              onChange={(event) => {
                setFormData((prev) => ({
                  ...prev,
                  status: formData.status === 1 ? 0 : 1,
                }));
              }}
            >
              Is active
            </Checkbox>
          </div>
        </div>
        <div className="flex justify-end space-x-3">
          <Button color="danger" variant="light" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit" className="bg-admin_black text-white">
            Save User
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserForm;
